if (!customElements.get('special-offer-modal')) {
  customElements.define(
    'special-offer-modal',
    class SpecialOfferModal extends ModalElement {
      constructor() {
        super();

        // Não abrir na página de verificação da Shopify
        if (
          window.location.pathname === '/challenge' ||
          !theme.cookiesEnabled
        ) {
          return;
        }

        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        } else {
          new theme.initWhenVisible(
            theme.utils.throttle(this.init.bind(this))
          );
        }
      }

      get shouldLock() {
        return true;
      }

      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }

      get delay() {
        return this.hasAttribute('data-delay')
          ? parseInt(this.getAttribute('data-delay'), 10)
          : 3;
      }

      get expiry() {
        return this.hasAttribute('data-expiry')
          ? parseFloat(this.getAttribute('data-expiry'))
          : 1;
      }

      get endTime() {
        return this.getAttribute('data-end-time');
      }

      get cookieName() {
        return 'concept:special-offer-popup';
      }

      get hasEnded() {
        if (!this.endTime) return false;

        const endDate = new Date(this.endTime);

        if (Number.isNaN(endDate.getTime())) {
          return false;
        }

        return Date.now() >= endDate.getTime();
      }

      init() {
        if (this.initialized) return;

        this.initialized = true;

        // Não mostrar depois do fim da campanha
        if (this.hasEnded) {
          return;
        }

        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }

      load(delay) {
        // No editor do tema, só abre quando estiver em modo de teste
        if (Shopify.designMode && !this.testMode) {
          return;
        }

        window.setTimeout(() => {
          if (!this.hasEnded) {
            this.show();
          }
        }, delay * 1000);
      }

      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }

      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');

        // Em modo de teste, não guardar o fecho
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }

        this.setCookie(this.cookieName, this.expiry);
      }

      getCookie(name) {
        const match = document.cookie.match(
          `(^|;)\\s*${name}\\s*=\\s*([^;]+)`
        );

        return match ? match[2] : null;
      }

      setCookie(name, expiry) {
        const maxAge = Math.round(expiry * 24 * 60 * 60);

        document.cookie =
          `${name}=true; max-age=${maxAge}; path=/; SameSite=Lax`;
      }

      removeCookie(name) {
        document.cookie =
          `${name}=; max-age=0; path=/; SameSite=Lax`;
      }
    }
  );
}